import React, { useEffect, useState } from "react";
import api from "../../api";

export default function AdminReasoningList() {

  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadData = async () => {
    try {
      const res = await api.get("/admin/reasoning/questions");
      setList(res.data.data || []);
    } catch (err) {
      alert("Failed to load reasoning questions");
    } finally {
      setLoading(false);
    }
  };

  const deleteItem = async (id) => {
    if (!window.confirm("Delete this question?")) return;

    try {
      await api.delete(`/admin/reasoning/question/${id}`);
      loadData();
    } catch (err) {
      alert("Delete failed");
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  if (loading) return <p>Loading...</p>;

  return (
    <div style={{ padding: 20 }}>
      <h2>Reasoning Questions</h2>

      <table border="1" cellPadding="8" cellSpacing="0" width="100%">
        <thead>
          <tr>
            <th>ID</th>
            <th>Image</th>
            <th>Class</th>
            <th>A</th>
            <th>B</th>
            <th>C</th>
            <th>D</th>
            <th>Correct</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {list.map(q => (
            <tr key={q.id}>
              <td>{q.id}</td>

              <td>
                {q.question_image && (
                  <img
                    src={`https://api.eduat10.com${q.question_image}`}
                    alt=""
                    width="60"
                  />
                )}
              </td>

              <td>{q.class_id}</td>
              <td>{q.option_a}</td>
              <td>{q.option_b}</td>
              <td>{q.option_c}</td>
              <td>{q.option_d}</td>
              <td><b>{q.correct}</b></td>

              <td>
                <button onClick={() => alert(JSON.stringify(q, null, 2))}>
                  View
                </button>{" "}
                <button onClick={() => alert("Edit next step")}>
                  Edit
                </button>{" "}
                <button onClick={() => deleteItem(q.id)}>
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
